import React, { Component } from 'react';
import { firebaseAuth,ref } from '../config/constants'
import moment from 'moment'
import {formatPrice,formatQuantity} from '../helpers/helpers'
import ReactTable from 'react-table'
import "react-table/react-table.css";

import Sidebar from './inc/Sidebar';
import Header from './inc/Header';
import Title from './inc/Title';
import Footer from './inc/Footer';

import PrintSheetInventory from './PrintSheetInventory'


class ReportsSheetsInventory extends Component {

    constructor(){
        super();
        this.print = this.print.bind(this)
        this.select = this.select.bind(this)
        this.range = this.range.bind(this)
        this.state = {
            user :{},
            sheets :{},
            display : "togglehide",
            querySheets : {},
            select : "All",
            fromDate : "",
            toDate : ""
        };
    }
    
    componentWillMount() {

        this.listener = firebaseAuth().onAuthStateChanged(user=>{
            if (user){
                
                var db = ref.child("users").child(user.uid);
                    db.on("value",function(data){
                      
                      this.setState({
                        userId : data.key,
                        user:data.val()
                      })


                    }.bind(this));
            }else{
              this.props.history.push("/login");
            }
        }); 

        let products = ref.child("StockCard").child("Sheets");
            products.on("value", function(snap){
                this.setState({
                    sheets : snap.val(),
                    querySheets : snap.val()
                })
            }.bind(this))

    }

    select(e){
        e.preventDefault();
        //console.log(this.option.value)
        var temp=[];

        if(this.option.value === "Custom"){
            this.setState({
                sheets : {},
                display : "toggleshow",
                select : this.option.value
            })
        }

        if(this.option.value === "Daily"){
            Object.keys(this.state.querySheets).map(key => {
                
                let list = this.state.querySheets[key] 
                let listDate = moment(list.date).format("MM DD YYYY")
                let nowDate = moment().format("MM DD YYYY") 
                
                if(moment(nowDate).isSame(listDate,'days')){
                   
                    list.date = moment(list.date).format("MM DD YYYY")
                    temp.push(list)
                }           
            })
            this.setState({
                sheets : temp,
                display : "togglehide",
                select : this.option.value
            }) 
        }

        if(this.option.value === "All"){
            Object.keys(this.state.querySheets).map(key => {
                let list = this.state.querySheets[key] 
                    temp.push(list)
            })
            this.setState({
                sheets : temp,
                display : "togglehide",
                select : this.option.value
            }) 
        }

        if(this.option.value === "Weekly"){
            Object.keys(this.state.querySheets).map(key => {
                
                let list = this.state.querySheets[key]
                let listDate = moment(list.date).format("MM DD YYYY")
                let nowDate = moment().format("MM DD YYYY") 
                if(moment(nowDate).isSame(listDate,'week')){
                    
                    list.date = moment(list.date).format("MM DD YYYY")
                    temp.push(list)   
                  
                }           
            })
            this.setState({
                sheets : temp,
                display : "togglehide",
                select : this.option.value
            }) 
        }

        if(this.option.value === "Monthly"){
            Object.keys(this.state.querySheets).map(key => {
                
                let list = this.state.querySheets[key]
                let listDate = moment(list.date).format("MM DD YYYY")
                let nowDate = moment().format("MM DD YYYY") 
                if(moment(nowDate).isSame(listDate,'month')){
                    
                    list.date = moment(list.date).format("MM DD YYYY")
                    temp.push(list)   
                  
                }
                          
            })
            this.setState({
                sheets : temp,
                display :"togglehide",
                select : this.option.value
            })
            
        }

    }

    print(){
        window.print();
    }

    range(e){
        e.preventDefault();
        if(this.daterange1.value && this.daterange2.value){
            let temp = []; 
            this.state.querySheets &&
            Object.keys(this.state.querySheets).map(key => {
                let list = this.state.querySheets[key] 
                let quoteDate = moment(list.date).format("MM DD YYYY") 
                let daterange1 = moment(this.daterange1.value).format("MM DD YYYY") 
                let daterange2 = moment(this.daterange2.value).format("MM DD YYYY")                                                                                        
                    if(moment(quoteDate).isBetween(daterange1,daterange2,'days',[])){                        
                        temp.push(list)                        
                    } 
            }) 
            this.setState({
                sheets : temp,
                fromDate : moment(this.daterange1.value).format("MM DD YYYY"),
                toDate : moment(this.daterange2.value).format("MM DD YYYY")
            })
        }else{
            alert("No date specified")
        }

        //this.formRange.reset();
       
    }

    componentDidUpdate(prevProps,prevState){
        if(prevState.sheets!==this.state.sheets){
            
            this.setState({
                sheets : this.state.sheets
            })
        }

        if(prevState.display!==this.state.display){
            
            this.setState({
                display : this.state.display
            })

        }

    }

    render() {
        
        var x =[];
        if (x.length === 0){
            this.state.sheets &&
            Object.keys(this.state.sheets).map(key => {
                let list = this.state.sheets[key]
                
                //list.formattedTotalQuote = formatPrice(price)
                list.date = moment(list.date).format("MM/DD/YYYY")
                list.color = list.color.toUpperCase();
                list.status = list.status.toUpperCase();
                list.count = formatQuantity(list.count);

                x.push(list) 
                       
            }) 
        }
         
         
        
        return (
            <div>
                <div id="page-wrapper" className="no-print">
                    <div id="page-container" className="sidebar-partial sidebar-visible-lg sidebar-no-animations">
                        <Sidebar  role={this.state.user.role} />
                        <div id="main-container">
                            <Header />
                            <div id="page-content">
                                <Title title="Reports" />
                                <div className="form-group ">
                                    <form onSubmit={this.select}>
                                    <select className="select-chosen" ref={(input)=>{this.option=input}} >
                                        <option>All</option>
                                        <option>Daily</option>
                                        <option>Weekly</option>
                                        <option>Monthly</option>
                                        <option>Custom</option>                                   
                                    </select>
                                    <button type="submit" className="btn btn-sm btn-primary inventorySubmit"><i className="fa fa-angle-right"></i> Submit</button>                                
                                    <button type="button" className="btn btn-sm btn-primary pull-right inventoryPrint" onClick={this.print}><i className="fa fa-print"></i> Print</button>
                                    </form>
                                </div><div className="clearfix"></div>
                                <div className="block">
                                    <div className={`${this.state.display}`}>
                                        <form  className="form-horizontal form-bordered" ref={(input) => {this.formRange=input}} onSubmit={this.range}>
                                            <fieldset>
                                                <div className="form-group">
                                                    <label className="col-md-4 control-label" htmlFor="example-daterange1">Select Date Range</label>
                                                    <div className="col-md-8">
                                                        <div className="input-group input-daterange" data-date-format="mm/dd/yyyy">
                                                            <input type="text" id="example-daterange1" name="daterange1" ref={(input)=>this.daterange1 = input} className="form-control text-center" placeholder="From" />
                                                            <span className="input-group-addon"><i className="fa fa-angle-right"></i></span>
                                                            <input type="text" id="example-daterange2" name="daterange2" ref={(input)=>this.daterange2 = input}className="form-control text-center" placeholder="To" />
                                                        </div>
                                                    </div>
                                                </div>
                                            </fieldset>
                                            <div className="form-group form-actions">
                                                <div className="col-md-8 col-md-offset-4">
                                                    <button type="submit" className="btn btn-sm btn-primary"><i className="fa fa-angle-right"></i> Submit</button>
                                                    <button type="reset" className="btn btn-sm btn-warning"><i className="fa fa-repeat"></i> Reset</button>
                                                </div>
                                            </div>
                                        </form>
                                    </div>
                                    <div>
                                        <ReactTable
                                            data={x}
                                            columns={[
                                                {
                                                    Header: "Date",
                                                    accessor : "date"
                                                },
                                                {
                                                    Header: "Dimension",
                                                    accessor : "dimension"
                                                },
                                                {
                                                    Header: "Length",
                                                    accessor : "length"
                                                },
                                                {
                                                    Header: "Thickness",
                                                    accessor : "thickness"
                                                },
                                                {
                                                    Header: "Color",
                                                    accessor : "color",
                                                    filterMethod : (filter, row, column) => {
                                                                    const id = filter.pivotId || filter.id
                                                                    return row[id] !== undefined ? String(row[id].toUpperCase()).includes(filter.value.toUpperCase()) : true
                                                                  },
                                                },
                                                {
                                                    Header: "In/Out",
                                                    accessor : "status",
                                                    filterMethod : (filter, row, column) => {
                                                                    const id = filter.pivotId || filter.id
                                                                    return row[id] !== undefined ? String(row[id].toUpperCase()).includes(filter.value.toUpperCase()) : true
                                                                  },

                                                },
                                                {
                                                    Header: 'Quantity',
                                                    accessor : "count",
                                                    Footer :(
                                                            <span>
                                                                <strong>Total:</strong>{" "}
                                                                { 
                                                                    formatQuantity(Object.keys(x)
                                                                        .reduce( function( sum, key){
                                                                            if (x[key].status==="IN"){
                                                                                return sum + parseFloat( x[key].count );                                                        
                                                                            }else{
                                                                                return sum - parseFloat( x[key].count );
                                                                            }
                                                                        }, 0 )
                                                                    )

                                                                }
                                                            </span>
                                                            )                                          
                                                }
                                            ]}
                                            
                                            filterable ={true}
                                            defaultPageSize={10}
                                            className="-striped -highlight"
                                        />                                
                                    </div>
                                </div>
                            </div>
                            <Footer />
                        </div>
                    </div>
                </div>
                <PrintSheetInventory title="Sheet" selected={this.state.select} data={x} fromDate={this.state.fromDate} toDate={this.state.toDate}/>
            </div>
        );
    }
}

export default ReportsSheetsInventory;



// WEBPACK FOOTER //
// ./src/components/ReportsSheetsInventory.js